export default __webpack_public_path__ + "234dc52c27411a8d88d465a816dfe743.png";